import styled from "styled-components";
import { breakpoints } from "styles/grid";

// #####################################################

export const StyledModalAuthWrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	min-height: 100lvh;
	background: rgba(0, 0, 0, 0.75);
	z-index: 1000;
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: hidden;
	@media (max-width: ${breakpoints.desktop - 1}px) {
		padding: 0;
		min-height: 100dvh;
	}
`;

// #####################################################
